/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_StaffInputs */

const id_staff_nav_staff = /** @type {(inputs: Staff_Nav_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staf`)
};

const en_staff_nav_staff = /** @type {(inputs: Staff_Nav_StaffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staff`)
};

/**
* | output |
* | --- |
* | "Staff" |
*
* @param {Staff_Nav_StaffInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_staff = /** @type {((inputs?: Staff_Nav_StaffInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_StaffInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_staff(inputs)
	return id_staff_nav_staff(inputs)
});